import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Button } from 'react-bootstrap'
import * as request from 'services/request'
import { MissingTokensIcon } from 'pages/admin/users/users'

class AssignUsersModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      users: [],
      selectedUser: null
    }

    this.addSelectedUser = this.addSelectedUser.bind(this)
    this.selectUser = this.selectUser.bind(this)
    this.handleUserSelected = this.handleUserSelected.bind(this)
  }

  componentDidMount () {
    this.getUsers()
  }

  componentDidUpdate () {
    // the select picker needs to be refreshed when we fetch the users
    window.$('.selectpicker').selectpicker('refresh')
  }

  async getUsers () {
    const response = await request.authorized(`/users`)
    const users = await response.json()

    this.setState({ users })
  }

  addSelectedUser () {
    const { selectedUser } = this.state
    const { onAddUser } = this.props

    onAddUser({
      id: selectedUser.id,
      screenName: selectedUser.screenName,
      role: 'user',
      permissions: null
    })
  }

  selectUser (id) {
    const { users } = this.state
    const user = users.find(u => u.id === id)
    this.setState({ selectedUser: user })
  }

  handleUserSelected (e) {
    this.selectUser(e.target.value)
  }

  render () {
    const { show, name, onClose } = this.props
    const { users, selectedUser } = this.state

    return (
      <Modal show={show}>
        <Modal.Header>
          <Modal.Title>
            Assign user to <strong>{name}</strong>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <select
            className='selectpicker form-control'
            title='Select a user'
            data-live-search='true'
            onChange={this.handleUserSelected}
          >
            {users.map(user => (
              <option key={user.id} value={user.id} >
                <div className='user-select-option'>
                  {user.screenName}
                  {
                    !user.hasTwitterTokens &&
                    <MissingTokensIcon />
                  }
                </div>
              </option>
            ))}
          </select>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            bsStyle='primary'
            onClick={this.addSelectedUser}
            disabled={!selectedUser}
          >
            Assign User
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

AssignUsersModal.propTypes = {
  onAddUser: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired
}

export default AssignUsersModal



// WEBPACK FOOTER //
// ./src/pages/admin/permissions/tenant-permissions/assign-users-modal.js